import { Link } from 'react-router-dom';

import {
  MessageCircle,
  Facebook,
  Linkedin,
  Instagram,
  Twitter,
  Phone,
  Globe,
  Clock,
  Goal,
  Mail,
  ArrowUpRight,
  Sparkles,
  Rocket,
} from "lucide-react";

const NAV = [
  ['Home', '/'],
  ['Services', '/services'],
  ['Projects', '/projects'],
  ['Apps', '/apps'],
  ['Courses', '/courses'],
  ['Team', '/team'],
  ['Reviews', '/testimonials'],
  ['Contact', '/contact']
];

const SRVCS = [
  'Website Development',
  'Mobile App Development',
  'Backend Development',
  'Payment Gateway',
  'SEO Optimization',
  'Domain & Hosting',
  'Website Deployment'
];

const SOCIALS = [
  {
    icon: MessageCircle,
    label: 'WhatsApp',
    url: 'https://wa.me/919499130923',
    hc: '#25d366'
  },
  {
    icon: Facebook,
    label: 'Facebook',
    url: 'https://facebook.com/vtcodex',
    hc: '#1877f2'
  },
  {
    icon: Linkedin,
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/company/vtcodex/',
    hc: '#0a66c2'
  },
  {
    icon: Instagram,
    label: 'Instagram',
    url: 'https://www.instagram.com/_vtcodex/',
    hc: '#e1306c'
  },
  {
    icon: Twitter,
    label: 'Twitter',
    url: 'https://x.com/_VTCODEX',
    hc: '#1da1f2'
  },
];

const CONTACT = [
  {
    icon: Phone,
    text: "+91 9306468015"
  },
  {
    icon: Phone,
    text: "+91 9729013924"
  },
  {
    icon: Mail,
    text: "contact@vtcodex.com",
    href: "mailto:contact@vtcodex.com"
  },
  {
    icon: Mail,
    text: "vtcodex1128@gmail.com",
    href: "mailto:vtcodex1128@gmail.com"
  },
  {
    icon: Globe,
    text: "www.vtcodex.com"
  },
  {
    icon: Clock,
    text: "Mon – Sat · 9AM – 8PM"
  },
  {
    icon: Goal,
    text: "24/7 Email Support"
  }
];

export default function Footer() {

  return (
    <footer className="relative overflow-hidden bg-[#050810] border-t border-white/5">

      {/* background */}
      <div className="absolute inset-0 overflow-hidden">

        <div
          className="absolute -left-40 top-0 w-[500px] h-[500px] rounded-full"
          style={{
            background:'radial-gradient(circle,rgba(0,245,255,.10) 0%,transparent 70%)',
            filter:'blur(60px)'
          }}
        />

        <div
          className="absolute -right-40 bottom-0 w-[500px] h-[500px] rounded-full"
          style={{
            background:'radial-gradient(circle,rgba(139,92,246,.12) 0%,transparent 70%)',
            filter:'blur(60px)'
          }}
        />

        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage:'linear-gradient(rgba(0,245,255,.03) 1px,transparent 1px),linear-gradient(90deg,rgba(0,245,255,.03) 1px,transparent 1px)',
            backgroundSize:'50px 50px'
          }}
        />

      </div>

      {/* main */}
      <div className="relative z-10 max-w-7xl mx-auto px-8 pt-20 pb-10">

        {/* top section */}
        <div
          className="mb-16 rounded-[2rem] border border-white/10 bg-white/[0.03]
          backdrop-blur-xl p-10"
        >

          <div className="grid grid-cols-1 lg:grid-cols-[1.2fr_.8fr_.8fr_1fr] gap-12">

            {/* brand */}
            <div>

              <Link
                to="/"
                className="flex items-center gap-4 no-underline mb-6"
              >

                <div
                  className="relative w-16 h-16 rounded-2xl overflow-hidden border border-cyan-400/20"
                  style={{
                    boxShadow:'0 0 30px rgba(0,245,255,.25)'
                  }}
                >
                  <img
                    src="/logo.jpeg"
                    alt="VTCodex"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div>

                  <h2 className="text-white text-4xl font-bold grad-text">
                    VTCodex
                  </h2>

                  <p className="text-slate-500 text-sm tracking-widest">
                    DIGITAL SOLUTIONS
                  </p>

                </div>

              </Link>

              <p className="text-slate-400 leading-relaxed max-w-[340px] mb-8">
                Building premium websites, applications and scalable
                digital systems for businesses, startups, schools
                and institutions.
              </p>

              <p className="text-slate-500 text-sm leading-relaxed max-w-[340px] mb-6">
                Founded by{' '}
                <a href="https://www.linkedin.com/in/vishalrana227" target="#" rel="me noopener noreferrer"
                  className="text-slate-300 hover:text-cyan-400 no-underline">Vishal Rana</a>{' '}(Founder) &amp;{' '}
                <a href="https://www.linkedin.com/in/tanisha-garg-70116b313" target="#" rel="me noopener noreferrer"
                  className="text-slate-300 hover:text-cyan-400 no-underline">Tanisha Garg</a>{' '}(Co-Founder).
              </p>

              {/* social */}
              <div className="flex gap-3 flex-wrap">

                {SOCIALS.map((s, i) => (
                  <a
                    key={i}
                    href={s.url}
                    target="#"
                    rel="noopener noreferrer"
                    className="group w-12 h-12 rounded-2xl flex items-center justify-center transition-all duration-500 hover:-translate-y-2"
                    style={{
                      background:`${s.hc}10`,
                      border:`1px solid ${s.hc}25`,
                      color:s.hc,
                    }}
                  >
                    <s.icon
                      size={20}
                      className="transition-transform duration-500 group-hover:scale-110"
                    />
                  </a>
                ))}

              </div>

            </div>

            {/* links */}
            <div>

              <div className="flex items-center gap-2 mb-6">

                <Sparkles
                  size={16}
                  color="#00f5ff"
                />

                <h3 className="text-white text-xl font-bold">
                  Quick Links
                </h3>

              </div>

              <ul className="flex flex-col gap-3 list-none">

                {NAV.map(([label, path], i) => (
                  <li key={i}>

                    <Link
                      to={path}
                      className="group flex items-center gap-2 text-slate-400 no-underline transition-all duration-300 hover:text-cyan-400 hover:translate-x-2"
                    >

                      <ArrowUpRight
                        size={15}
                        className="opacity-0 group-hover:opacity-100 transition-all duration-300"
                      />

                      {label}

                    </Link>

                  </li>
                ))}

              </ul>

            </div>

            {/* services */}
            <div>

              <div className="flex items-center gap-2 mb-6">

                <Rocket
                  size={16}
                  color="#8b5cf6"
                />

                <h3 className="text-white text-xl font-bold">
                  Services
                </h3>

              </div>

              <ul className="flex flex-col gap-3 list-none">

                {SRVCS.map((s, i) => (
                  <li key={i}>

                    <Link
                      to="/services"
                      className="text-slate-400 no-underline transition-all duration-300 hover:text-[#8b5cf6] hover:translate-x-2 flex items-center gap-2"
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-[#8b5cf6]" />
                      {s}
                    </Link>

                  </li>
                ))}

              </ul>

            </div>

            {/* contact */}
            <div>

              <div className="flex items-center gap-2 mb-6">

                <MessageCircle
                  size={16}
                  color="#f472b6"
                />

                <h3 className="text-white text-xl font-bold">
                  Contact
                </h3>

              </div>

              <div className="flex flex-col gap-4">

                {CONTACT.map((c, i) => (
                  <div
                    key={i}
                    className="flex items-start gap-3"
                  >

                    <div
                      className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                      style={{
                        background:'rgba(244,114,182,.08)',
                        border:'1px solid rgba(244,114,182,.18)'
                      }}
                    >
                      <c.icon
                        size={16}
                        color="#f472b6"
                      />
                    </div>

                    <div className="pt-1">

                      {c.href ? (
                        <a
                          href={c.href}
                          className="text-slate-400 no-underline hover:text-[#f472b6] transition-colors duration-300 text-sm"
                        >
                          {c.text}
                        </a>
                      ) : (
                        <p className="text-slate-400 text-sm">
                          {c.text}
                        </p>
                      )}

                    </div>

                  </div>
                ))}

              </div>

            </div>

          </div>

        </div>

        {/* bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">

          <p className="text-slate-600 text-sm text-center md:text-left">
            © {new Date().getFullYear()} VTCodex · Founders: Vishal Rana & Tanisha Garg · All rights reserved
          </p>

          <div className="flex items-center gap-2 text-slate-600 text-sm">

            <span>Built with</span>

            <span className="text-pink-400">❤</span>

            <span>by VTCodex</span>

          </div>

        </div>

      </div>

    </footer>
  );
}